import { ILoggerToken, LogLevel } from './ILogger.js';
import { ILogReaderToken } from './ILogReader.js';
import { services } from '@quandis/qbo4.ui';
/**
 * A simple in-memory logger that stores log entries in memory.
 */
export class MemoryLogger {
    constructor() {
        this.logs = [];
    }
    logTrace(message, ...args) {
        this.logs.push({ logLevel: LogLevel.Trace, message, args });
    }
    logDebug(message, ...args) {
        this.logs.push({ logLevel: LogLevel.Debug, message, args });
    }
    logInformation(message, ...args) {
        this.logs.push({ logLevel: LogLevel.Information, message, args });
    }
    logWarning(message, ...args) {
        this.logs.push({ logLevel: LogLevel.Warning, message, args });
    }
    logError(message, error, ...args) {
        this.logs.push({ logLevel: LogLevel.Error, message, error, args });
    }
    logCritical(message, error, ...args) {
        this.logs.push({ logLevel: LogLevel.Critical, message, error, args });
    }
    log(level, message, error, ...args) {
        this.logs.push({ logLevel: level, message, error, args });
    }
    /**
     * Retrieves all log entries.
     */
    getLogs() {
        return this.logs;
    }
    /**
     * Clears all log entries from memory.
     */
    clearLogs() {
        this.logs = [];
    }
}
services.container.registerSingleton(MemoryLogger);
services.container.register(ILoggerToken, { useToken: MemoryLogger });
services.container.register(ILogReaderToken, { useToken: MemoryLogger });
//# sourceMappingURL=MemoryLogger.js.map